const tmrMetrica = (id) => {
    if (typeof window === 'undefined' || typeof window._tmr === 'undefined' || !id) {
        return;
    }

    try {
        window._tmr.push({type: 'reachGoal', id: 3251474, goal: id});
    } catch (error) {
        console.error(error);
    }
};

export default (_, inject) => {
    inject('tmr', tmrMetrica);
};
